import Axios from "axios";
import Vue from "vue";
import i18n from "../../i18n";
import { API_HOST } from "../../config/app-const";
import _ from "lodash";
import { normalize } from "../../helpers/pagination";
import { filtersToQuery } from '../../helpers/filters';

const state = {
  coderProfile: {
    isBusy: false,
    data: null,
    error: null
  },
}

const mutations = {
  LOAD_CODER_PROFILE_BUSY: (state, payload) => {
    state.coderProfile.isBusy = payload;
  },
  LOAD_CODER_PROFILE_SUCCESS: (state, payload) => {
    state.coderProfile.data = payload;
    state.coderProfile.error = null;
  },
  REFRESH_CODER_PROFILE: (state, payload) => {
    state.coderProfile.data = { ...state.coderProfile.data, ...payload };
    state.coderProfile.error = null;
  },
  LOAD_CODER_PROFILE_FAIL: (state, payload) => {
    state.coderProfile.data = null;
    state.coderProfile.error = payload;
  },
}


const actions = {
  getCoderProfile: ({ commit, rootState }, { coderId }) => {
    commit("LOAD_CODER_PROFILE_BUSY", true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return Axios.get(`${API_HOST}/analysis/coder/${coderId}`, config)
      .then(response => {
        commit("LOAD_CODER_PROFILE_SUCCESS", response.data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("LOAD_CODER_PROFILE_FAIL", error);
      })
      .finally(() => commit("LOAD_CODER_PROFILE_BUSY", false));
  },
  refreshCoderProfile: ({ commit }, coderProfile) => {
    commit("REFRESH_CODER_PROFILE", coderProfile);
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
